











































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Mutation, State, Action } from 'vuex-class';
import { v4 as uuidv4 } from 'uuid';
import { ProductPrices, MoonPay, AuthQuery } from '~/mixins';
import FullScreenDialog from '~/components/FullScreenDialog.vue';
import CheckoutItemDetails from '~/components/Store/CheckoutItemDetails.vue';
import CheckoutPurchaseControls from '~/components/Store/CheckoutPurchaseControls.vue';
import Web3WalletOrderPayment from '~/components/Store/Web3WalletPayment.vue';
import OrderConfirmation from '~/components/Games/Items/OrderConfirmation.vue';
import AboutThisGame from '~/components/Games/AboutThisGame.vue';
import NumberInput from '~/components/UIComponents/NumberInput.vue';
import Confirm from '~/components/Store/Confirm.vue';
import SimilarItems from '~/components/Games/Items/SimilarItems.vue';
import TwoFactorAuthInputPrompt from '~/components/ModalPrompts/TwoFactorAuthInputPrompt.vue';
import { IGame, IPurchaseAgreement } from '~/store/games/types';
import { IWallet } from '~/store/inventory/types';
import { IAcceptedLegalDocument } from '~/types/coinpayments';
import {
  IExternalWalletOrderResponse,
  NumericTransactionType,
} from '~/types/gala-store';
import {
  getNewPriceFromError,
  isPriceMismatchError,
  isPriceAdjustmentError,
} from '~/utils/errorCodes';
import isQualified from '../../queries/isQualified.gql';
import {
  isRestrictionSuccess,
  getFirstRestrictionSuccessResultByFilter,
  isSuccessfulPriceAdjustmentCodeBased,
} from '~/utils/parseRestrictionResults';
import { defaultGyriGachaLoadingVideo } from '~/utils/gyri_exchange';
import { FetchResult } from 'apollo-link';
import { IDocumentsAccepted } from '../../types/legal-documents';
import { TwoFaCheckpoint } from '../../types/two-fa-checkpoints';
import { FiatProvider } from '../../types/fiat-provider';
import Stripe from '../../mixins/Stripe';
import { StripeElements } from '@stripe/stripe-js';
import { IUser } from '../../store/profile/types';

@Component({
  components: {
    FullScreenDialog,
    OrderConfirmation,
    NumberInput,
    CheckoutItemDetails,
    CheckoutPurchaseControls,
    Web3WalletOrderPayment,
    Confirm,
    SimilarItems,
    AboutThisGame,
    TwoFactorAuthInputPrompt,
  },
})
export default class Checkout extends Mixins(
  ProductPrices,
  MoonPay,
  AuthQuery,
  Stripe,
) {
  @State(inventory => inventory.wallets, { namespace: 'inventory' })
  wallets!: IWallet[];
  @Mutation('incrementWalletBalance', { namespace: 'inventory' })
  incrementWalletBalance!: (payload: {
    symbol: string;
    amount: number;
  }) => void;
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State(games => games.games, { namespace: 'games' })
  games!: IGame[];
  @State(profile => profile.user, { namespace: 'profile' })
  user!: IUser;

  @Prop(Function) completeCheckout!: (
    passcode: string,
    productId: string,
    paymentCurrency: string,
    quantity: number,
    transactionFee: number,
    expectedPrice: number,
    priceAdjustmentCode?: string,
  ) => FetchResult<any, Record<string, any>, Record<string, any>>;
  @Prop(Function) placeW3wOrder!: (
    productId: string,
    paymentCurrency: string,
    quantity: number,
    transactionFee: number,
    expectedPrice: number,
    appliedDiscountCode?: string,
  ) => Promise<IExternalWalletOrderResponse>;
  @Prop(Function) updateProductCategory!: (category: string) => void;
  @Prop(String) itemId!: string;
  @Prop(String) mutationName!: string;
  @Prop({ type: Boolean, default: false }) continueButtonsDisabled!: boolean;
  @Prop({ type: Boolean, default: true }) showQuantitySelector!: boolean;
  @Prop({ type: Array, default: () => [] })
  readonly acceptedLegalDocuments!: IAcceptedLegalDocument[];

  @Prop(Array)
  agreements!: IPurchaseAgreement[];

  @Action('getNewNotifications', { namespace: 'notifications' })
  getNewNotifications!: () => void;
  @Action('promptToRegister')
  private promptToRegister!: (options?: {
    redirectAfterLoginPath?: string;
  }) => void;

  @Mutation toggleErrorSnackbar!: (payload?: boolean) => void;
  @Mutation updateSnackbarErrorText!: (args: any) => void;

  idempotencyKey: string = uuidv4();
  paymentHash = '';
  orderId = '';
  isSuccessful = false;
  showPriceChangeModal = false;
  showPriceAdjusmentError = false;
  disableContinueButton = false;
  interval: any = null;
  end = 0;
  isQualified = !process.env.enableRestrictionsService;
  disqualifiedMessage = '';
  isRestrictionsServiceInitialized = false;
  orderPaymentData: null | {
    blockSigned: number;
    contractMethod: string;
    ethAmount: string;
    inputs: any[];
    refId: string;
    smartContractAbi: string;
    smartContractAddress: string;
    transactionFeePrice: number;
  } = null;
  showW3wPaymentView = false;
  priceAdjustmentId: any = null;
  submittedDiscountCode = '';
  appliedDiscountCode = '';
  incorrectDiscountCodeMessage = '';
  isDiscountLoading = false;
  appliedPriceAdjustmentData: any[] | null = null;
  performingExchange = false;
  isAppliedPriceAdjustmentCodeBased = false;
  transactionFee?: number;

  get maxQuantityPerOrder() {
    return this.item?.maxQuantityPerOrder;
  }

  get customPurchaseLoadingVideoUrl() {
    if (
      this.performingExchange &&
      this.item?.autoOpenAsGyriExchange &&
      this.item?.gyriExchanges?.length
    ) {
      const game = this.games.find(game => game.name === this.item?.game);

      return game?.customGyriGachaLoadingVideo ?? defaultGyriGachaLoadingVideo;
    }
  }

  get imageUrl() {
    return this.item
      ? this.item.image ||
          this.item.images[0].thumbnail ||
          this.item.images[0].url
      : '';
  }

  get buyNowButtonText() {
    if (this.item && this.item.rarity) {
      if (this.soldOut) {
        return this.$t('components.store.checkout.soldOut') as string;
      }
      if (this.quantity > this.item.qtyLeft) {
        return this.$t('components.store.checkout.insufficient') as string;
      }
    }
    return this.$t('components.store.checkout.placeOrder') as string;
  }

  get buttonsDisabled() {
    const inufficientInventory =
      this.item && this.item.rarity && this.item.qtyLeft < this.quantity;
    const selectedPriceIsCC = this.selectedPrice.symbol.startsWith('CC');

    if (this.prices.length === 1 && selectedPriceIsCC && !this.selectedCredit) {
      this.selectedCredit = FiatProvider.STRIPE; // hack
    }

    const buttonsDisabled =
      this.continueButtonsDisabled ||
      this.soldOut ||
      inufficientInventory ||
      this.disableContinueButton ||
      (selectedPriceIsCC && !this.selectedCredit);

    return buttonsDisabled;
  }

  get hasTransactionFee() {
    return (
      !this.selectedPrice.symbol.includes('[GC]') &&
      !this.selectedPrice.symbol.startsWith('CC') &&
      !this.selectedPrice.symbol.includes('[GYRI]')
    );
  }

  get orderDetails() {
    const imageUrl =
      this.selectedPrice.imageUrl ||
      (this.selectedPrice.symbol
        ? require(`@/assets/logos/${this.selectedPrice.symbol.replace(
            /\[ETH\]|\[GC\]/g,
            '',
          )}-icon.png`)
        : '');
    return {
      product: { ...this.item, image: this.item?.images[0].url },
      quantity: this.quantity,
      paymentHash: this.paymentHash,
      orderId: this.orderId,
      creditCard: this.selectedPrice.creditCard,
      selectedPrice: { ...this.selectedPrice, imageUrl },
      rebateInUsd: this.selectedPriceRebateInUsd,
      transactionFee: this.hasTransactionFee
        ? {
            fee: this.transactionFee,
            currency: 'ETH',
          }
        : null,
    };
  }

  get isRestricted() {
    return !this.isQualified;
  }

  get quantityMultiplier() {
    return this.item?.quantityMultiplier || 1;
  }

  get doesPriceAdjustmentRequireDiscountCode() {
    // As a naming convention, if any priceAdjustment value in the priceAdjustmentId restriction
    // requires a discount code, then the restriction id name should begin with 'CODE'
    return /^CODE/.test(this.priceAdjustmentId);
  }

  get doesPriceAdjustmentHaveCodeAndAuto() {
    // As a naming convention, if the restriction associated with the priceAdjustmentId
    // includes both a priceAdjustment that requires a discount code AND a priceAdjustment that should be automatically applied,
    // then the restriction id name should begin with 'CODE_AUTO'
    return /^CODE_AUTO/.test(this.priceAdjustmentId);
  }

  get showOrderConfirmation() {
    const validMutationName =
      this.mutationName === 'orderProduct' ||
      this.mutationName === 'orderProductV2';

    return this.paymentHash || (validMutationName && this.isSuccessful);
  }

  async mounted() {
    await this.fetchItem(this.itemId);
    await this.isRestrictedCheck();

    if (this.quantityMultiplier > 1) {
      this.updateQuantityWithMultiplier(this.quantityMultiplier);
    }

    if (this.item?.category) {
      this.updateProductCategory(this.item.category);
    }

    this.checkForPriceAdjustment();
  }

  async handleContinue() {
    if (this.selectedPrice.symbol.startsWith('CC')) {
      const creditCardMaxPurchase = process.env.creditCardMaxPurchase
        ? +process.env.creditCardMaxPurchase
        : 5500;
      if (!this.loggedIn) {
        this.promptToRegister({ redirectAfterLoginPath: this.$route.fullPath });
        return;
      } else if (this.calculatedPrice > creditCardMaxPurchase) {
        this.updateSnackbarErrorText(
          this.$t('components.store.checkout.creditCardPurchaseLimit', {
            max: creditCardMaxPurchase,
          }),
        );
        this.toggleErrorSnackbar();
        return;
      }
    }

    if (this.selectedCredit === FiatProvider.MOONPAY) {
      this.handleMoonPayBuy();
    } else if (this.selectedCredit === FiatProvider.STRIPE) {
      this.handleContinueToBuy();
    } else {
      this.handleContinueToBuy();
    }
  }

  async checkForPriceAdjustment() {
    if (this.item?.priceAdjustmentId) {
      this.priceAdjustmentId = this.item.priceAdjustmentId;

      if (!this.doesPriceAdjustmentRequireDiscountCode) {
        await this.applyPriceAdjustment();
      } else {
        const queryPriceAdjustmentCode = this.$router.currentRoute?.query
          ?.priceAdjustmentCode
          ? (this.$router.currentRoute.query.priceAdjustmentCode as string)
          : '';

        if (queryPriceAdjustmentCode) {
          await this.handleDiscountCode(queryPriceAdjustmentCode);
        } else if (this.doesPriceAdjustmentHaveCodeAndAuto) {
          await this.applyPriceAdjustment('n/a');
        }
      }
    }
  }

  async applyPriceAdjustment(discountCode?: string) {
    this.appliedPriceAdjustmentData = null;

    if (
      !process.env.enableRestrictionsService ||
      !this.priceAdjustmentId ||
      !this.item?.productId ||
      !this.loggedIn
    ) {
      return;
    }

    this.isDiscountLoading = true;
    const discountedPrices = await this.getPriceAdjustment(discountCode);

    if (discountedPrices) {
      try {
        await this.fetchItem(this.itemId, discountedPrices);
        this.onDiscountSuccess();
        this.isDiscountLoading = false;
        this.appliedPriceAdjustmentData = discountedPrices;
      } catch (err) {
        this.submittedDiscountCode = '';
        this.updateSnackbarErrorText(
          this.$t('components.store.checkout.thereWasAProblem'),
        );
        this.toggleErrorSnackbar();
        this.isDiscountLoading = false;
      }
    } else {
      this.incorrectDiscountCodeMessage = this.$t(
        'components.store.checkout.noPromotionWasFound',
      ) as string;
      this.isDiscountLoading = false;
    }
  }

  async getPriceAdjustment(discountCode?: string) {
    let newPrices;
    let payload: any = {
      productId: this.item?.productId,
      quantity: this.quantity,
    };

    if (discountCode) {
      payload.code = discountCode;
    }

    const { data } = await this.$apollo.query({
      query: isQualified,
      variables: {
        id: this.priceAdjustmentId,
        payload,
      },
    });

    const isQualifiedForPriceAdjustment = isRestrictionSuccess(
      data.isQualified,
    );

    if (isQualifiedForPriceAdjustment) {
      const isPriceAdjustmentCodeBased = isSuccessfulPriceAdjustmentCodeBased(
        data.isQualified,
      );
      this.isAppliedPriceAdjustmentCodeBased = isPriceAdjustmentCodeBased;

      newPrices = getFirstRestrictionSuccessResultByFilter(
        data.isQualified,
        'priceAdjustment',
        'prices',
      );
    }

    return newPrices;
  }

  onDiscountSuccess() {
    if (this.isAppliedPriceAdjustmentCodeBased) {
      this.appliedDiscountCode = this.submittedDiscountCode;
    }

    // If a priceAdjustmentId includes both code-based and automatic price adjustments,
    // and the user enters an invalid discount code, we need to be able to alert the user
    // that the entered code is invalid, even though the automatic discount will be successfully applied
    if (!this.isAppliedPriceAdjustmentCodeBased && this.submittedDiscountCode) {
      this.incorrectDiscountCodeMessage = this.$t(
        'components.store.checkout.noPromotionWasFound',
      ) as string;
    }

    this.submittedDiscountCode = '';
  }

  async handleDiscountCode(discountCode: string) {
    this.submittedDiscountCode = discountCode;
    this.incorrectDiscountCodeMessage = '';
    this.applyPriceAdjustment(this.submittedDiscountCode);
  }

  async removeDiscount() {
    this.appliedDiscountCode = '';
    this.submittedDiscountCode = '';
    this.appliedPriceAdjustmentData = null;
    await this.fetchItem(this.itemId);
    this.checkForPriceAdjustment();
  }

  updateQuantityWithMultiplier(multiplier: number) {
    if (this.quantity < multiplier) {
      // Min quantity should be 1x the multiplier
      this.quantity = multiplier;
    } else {
      // Otherwise set the quantity to the closest multiple
      // without going over
      const overage = this.quantity % multiplier;
      this.quantity = this.quantity - overage;
    }
  }

  beforeDestroy() {
    clearInterval(this.interval);
  }

  async isRestrictedCheck() {
    if (!process.env.enableRestrictionsService || !this.item?.restrictionId) {
      this.isQualified = true;
      this.isRestrictionsServiceInitialized = true;
      return;
    }

    if (this.loggedIn) {
      const { data } = await this.$apollo.query({
        query: isQualified,
        variables: {
          id: this.item.restrictionId,
          payload: {
            productId: this.item.productId,
            quantity: this.quantity,
          },
        },
      });

      const uaPayload = {
        item: {
          productId: this.item.productId,
          quantity: this.quantity,
        },
        restrictionId: this.item.restrictionId,
        restrictionResults: data?.isQualified,
      };

      if (data?.isQualified?.success === true) {
        this.isQualified = true;

        //UA tracking
        this.$ua.trackProductRestrictionSatisfiedEvent(uaPayload);
      } else if (data?.isQualified?.success === false) {
        this.isQualified = false;
        this.disqualifiedMessage = data.isQualified.reason;

        //UA tracking
        this.$ua.trackProductRestrictionSatisfiedEvent(uaPayload);
      }
      this.isRestrictionsServiceInitialized = true;
    } else {
      this.isQualified = true;
      this.isRestrictionsServiceInitialized = true;
    }
  }

  async handleCompleteCheckout(passcode: string, transactionFee: number) {
    if (this.item) {
      try {
        let finalDiscountCode = this.appliedDiscountCode;
        if (
          this.doesPriceAdjustmentHaveCodeAndAuto &&
          !this.appliedDiscountCode
        ) {
          finalDiscountCode = 'n/a';
        }

        const results = await this.completeCheckout(
          passcode,
          this.item.productId,
          this.selectedPrice.symbol,
          this.quantity,
          transactionFee,
          Number(this.selectedPrice.price),
          finalDiscountCode,
        );

        this.incrementWalletBalance({
          amount: Number(this.selectedPrice.price) * this.quantity * -1,
          symbol: this.selectedPrice.symbol,
        });

        const autoOpenExchangeId = this.item.autoOpenAsGyriExchange
          ? this.item.gyriExchanges?.[0].id
          : undefined;

        if (
          results?.data?.orderProductV2?.instaFulfilledGyriTokens?.[0] &&
          autoOpenExchangeId
        ) {
          this.performingExchange = true;
          await this.$store.dispatch('inventory/exchangeGyriTokens', {
            totpToken: '', // shouldn't be needed due to minute-long no-2FA-needed exchange window granted by backend
            exchangeId: autoOpenExchangeId,
            walletPassword: passcode,
            tokens: results.data.orderProductV2.instaFulfilledGyriTokens,
          });
        }

        return results;
      } catch (err) {
        this.performingExchange = false;
        if (isPriceMismatchError(err)) {
          const selectedPrice = this.selectedPrice.price;
          const newPrice = getNewPriceFromError(err);

          // UA tracking
          this.$ua.trackPurchasePriceMismatchEvent({
            selectedPrice,
            newPrice,
          });

          this.selectedPrice.price = newPrice.toString();
          this.showPriceChangeModal = true;
        } else if (isPriceAdjustmentError(err)) {
          this.showPriceAdjusmentError = true;
          this.$ua.trackPurchaseErrorEvent(err);
        } else {
          // UA tracking
          this.$ua.trackPurchaseErrorEvent(err);

          throw err;
        }
      }
    }
  }

  async handleOrderWithW3w(transactionFeePrice: number) {
    if (this.item) {
      try {
        let finalDiscountCode = this.appliedDiscountCode;

        if (
          this.doesPriceAdjustmentHaveCodeAndAuto &&
          !this.appliedDiscountCode
        ) {
          finalDiscountCode = 'n/a';
        }

        const { success, message, paymentData } = await this.placeW3wOrder(
          this.item.productId,
          this.selectedPrice.symbol,
          this.quantity,
          transactionFeePrice,
          Number(this.selectedPrice.price),
          finalDiscountCode,
        );
        if (success && paymentData) {
          const {
            smartContractAbi,
            smartContractAddress,
            orderPaymentMessage,
            signedMessage,
          } = paymentData;

          const {
            orderId,
            transBlock,
            token,
            amount,
            transType,
            chainId,
            systemName,
            wallet,
          } = orderPaymentMessage;

          const inputs = token
            ? [
                [
                  orderId,
                  token,
                  amount,
                  transBlock,
                  transType,
                  systemName,
                  chainId,
                  wallet,
                  signedMessage,
                ],
              ]
            : [
                [
                  orderId,
                  amount,
                  transBlock,
                  systemName,
                  chainId,
                  wallet,
                  signedMessage,
                ],
              ];

          const contractMethod = !transType
            ? 'payETH'
            : transType === NumericTransactionType.burn
            ? 'payAndBurnERC20'
            : 'payAndTransferERC20';

          // set orderPaymentData on state
          this.orderPaymentData = {
            blockSigned: transBlock,
            contractMethod,
            ethAmount: this.selectedPrice.symbol === 'ETH' ? amount : '0',
            inputs,
            refId: orderId,
            smartContractAbi,
            smartContractAddress,
            transactionFeePrice,
          };
          // toggle pay with w3w view
          this.showW3wPaymentView = true;
          this.confirmDialog = false;
        } else if (message) {
          this.updateSnackbarErrorText(
            message ||
              (this.$t('common.notifications.somethingWentWrong') as string),
          );
          this.toggleErrorSnackbar();
        }
      } catch (err) {
        if (isPriceMismatchError(err)) {
          const selectedPrice = this.selectedPrice.price;
          const newPrice = getNewPriceFromError(err);

          // UA tracking
          this.$ua.trackPurchasePriceMismatchEvent({
            selectedPrice,
            newPrice,
          });

          this.selectedPrice.price = newPrice.toString();
          this.showPriceChangeModal = true;
        } else {
          this.updateSnackbarErrorText(
            this.$t('common.notifications.somethingWentWrong') as string,
          );
          this.toggleErrorSnackbar();
          // UA tracking
          this.$ua.trackPurchaseErrorEvent(err);
          throw err;
        }
      }
    }
  }

  closeW3wPaymentView() {
    this.showW3wPaymentView = false;
    this.orderPaymentData = null;
  }

  purchaseComplete(res: { success: boolean; results: any; message?: string }) {
    const success =
      res.results && res.results[this.mutationName]
        ? res.results[this.mutationName].success
        : res.success;
    switch (success) {
      case true:
        this.confirmDialog = false;
        if (!this.performingExchange) {
          this.successDialog = true;
        }

        this.performingExchange = false;
        this.paymentHash = res.results[this.mutationName].paymentHash;
        this.isSuccessful = res.results[this.mutationName].success;
        this.orderId = res.results[this.mutationName].orderId;
        this.getNewNotifications();

        // UA tracking
        this.$ua.trackPurchaseCompleteEvent({
          isSuccessful: this.isSuccessful,
          paymentHash: this.paymentHash,
          results: res.results[this.mutationName],
        });

        this.$emit('purchase-complete', true);
        break;
      case false:
        // UA tracking
        this.$ua.trackPurchaseErrorEvent(res);

        const message =
          res.message ||
          (res.results &&
            res.results[this.mutationName] &&
            res.results[this.mutationName].message);
        this.updateSnackbarErrorText(
          message ||
            (this.$t('common.notifications.transactionFailed') as string),
        );
        this.toggleErrorSnackbar();
        break;
      default:
        return;
    }
  }

  handleWeb3WalletComplete(res: { orderId: string; transactionHash: string }) {
    this.orderId = res.orderId;
    this.paymentHash = res.transactionHash;
  }

  async handleMoonPayBuy() {
    await this.doAuthQuery(async totpToken => {
      await this.showMoonpay(
        this.item?.productId as string,
        this.quantity,
        Number(this.selectedPrice.price),
        totpToken,
        [] as IDocumentsAccepted,
        this.appliedDiscountCode,
      );
    }, TwoFaCheckpoint.purchases);
  }

  async handleOrderWithStripe(stripeElement: StripeElements) {
    await this.doAuthQuery(async totpToken => {
      const result = await this.stripeMixinConfirmStripePayment(
        stripeElement,
        this.user.email,
        {
          productId: this.item?.productId as string,
          quantity: this.quantity,
          expectedPrice: Number(this.selectedPrice.price),
          totpToken,
          acceptedDocuments: [] as IDocumentsAccepted,
          priceAdjustmentCode: this.appliedDiscountCode,
        },
      );

      if (result.success === false) {
        this.updateSnackbarErrorText(result.message);
        this.toggleErrorSnackbar();
      }
    }, TwoFaCheckpoint.purchases);
  }

  get selectedPriceRebateInUsd() {
    const rebatePercentage = this.selectedPrice?.rebate
      ?.percentageOfUsdPurchasePrice;

    if (rebatePercentage && this.selectedPrice?.usdPriceInCents) {
      const discountPriceInCents =
        (this.selectedPrice.usdPriceInCents / 100) * rebatePercentage;

      return discountPriceInCents / 100;
    }
    return 0;
  }

  @Watch('quantity')
  onQuantityChange() {
    this.isRestrictedCheck();
  }

  @Watch('loggedIn')
  onLogin() {
    this.checkForPriceAdjustment();
  }
}
